import styled from 'styled-components';

export const EditSystemPlanPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EditSystemPlanTitleBlock = styled.div`
  display: flex;
  gap: 16px;
  padding: 24px;
  flex-direction: column;
  gap: 8px;
`;

export const EditSystemPlanContentBlock = styled.div`
  padding: 24px;
`;

export const SubsystemBlockWrapper = styled.div`
  margin-bottom: 24px;
  gap: 16px;
  display: flex;
  flex-direction: column;
`;

export const SubsystemTitle = styled.div`
  margin-bottom: 12px;
`;

export const EditSystemPlanActions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 24px 24px;
`;
